

/* Updated Sidebar component */
/* eslint-disable */

import { HiX, HiMenu } from "react-icons/hi";
import { useState, useEffect } from "react";
import Links from "./components/Links";
import SidebarCard from "components/sidebar/componentsrtl/SidebarCard";
import routes from "routes.js";

const Sidebar = ({ open: propOpen, onClose }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(propOpen || false);

  // Check if screen is mobile (less than 1190px)
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1190); // set breakpoint at 1190px
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Handle sidebar state based on screen size
  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false); // always closed initially on mobile
    } else {
      setSidebarOpen(true); // always open if >= 500px
    }
  }, [isMobile, propOpen]);

  const handleToggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleCloseSidebar = () => {
    setSidebarOpen(false);
    if (onClose) onClose();
  };

  const handleMenuItemClick = () => {
    if (isMobile) {
      setSidebarOpen(false);
      if (onClose) onClose();
    }
  };

  return (
    <>
      {/* Mobile Header Spacer */}
      {isMobile && (
        <div className="fixed top-0 left-0 right-0 h-16 bg-white dark:bg-navy-900 z-30 border-b border-gray-200 dark:border-gray-700 xl:hidden">
          {/* Optional Header Title */}
        </div>
      )}

      {/* Hamburger Button for mobile */}
      {isMobile && !sidebarOpen && (
        <div className="fixed top-4 left-4 z-50">
          <button
            onClick={handleToggleSidebar}
            className="flex items-center justify-center w-10 h-10 bg-white dark:bg-navy-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-navy-700 transition-colors duration-200"
          >
            <HiMenu className="w-6 h-6 text-gray-700 dark:text-white" />
          </button>
        </div>
      )}

      {/* Overlay on mobile */}
      {isMobile && sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={handleCloseSidebar}
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl transition-all dark:bg-navy-800 dark:text-white 
        ${sidebarOpen ? "translate-x-0" : "-translate-x-96"}
        ${!isMobile ? "" : ""}`}
      >
        {/* Close Button for mobile */}
        {isMobile && (
          <span
            className="absolute top-4 right-4 cursor-pointer"
            onClick={handleCloseSidebar}
          >
            <HiX className="w-6 h-6 text-gray-700 dark:text-white hover:text-gray-900 dark:hover:text-gray-300" />
          </span>
        )}

        {/* Logo */}
        <div className="mx-[56px] mt-[30px] flex items-center">
          <div className="mt-1 ml-1 h-2.5 font-poppins text-[26px] font-bold uppercase text-[#014d4d] dark:text-white">
            MEDSTOWN
            <sup style={{ fontSize: "11px", top: "-1.2em" }}>TM</sup>
          </div>
        </div>
        <div className="mt-[58px] h-px bg-gray-300 dark:bg-white/30" />

        {/* Sidebar Links */}
        <ul className="overflow-y-auto h-[calc(100vh-120px)]">
          <Links routes={routes} onMenuItemClick={handleMenuItemClick} />
        </ul>
      </div>
    </>
  );
};

export default Sidebar;

